import { useState } from "react";
import styles from "./../styles.module.css";
import { MetaFisica } from "../../../../model/PlanoDeTrabalho/CronogramaExecucao";
import Modal from "react-responsive-modal";
import ModalMetaExecucaoFisica from "../../../../components/ModalForms/ModalMetaExecucaoFisica";
import Table from "../../../../components/TableConstructor";
import RowCronoFisico from "../../../../components/TableConstructor/Row/RowCronoFisico";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaMetas: MetaFisica[];
  setMetas: React.Dispatch<React.SetStateAction<MetaFisica[]>>;
};

function CronogramaExecucao({
  passarPagina,
  voltarPagina,
  listaMetas,
  setMetas,
}: Props) {
  const [showModel, setModal] = useState(false);
  const [showEditModelIndex, setEditModalIndex] = useState(-1);

  return (
    <div>
      <h2 className={styles.titulo}>
        2.1. Descreva o <strong>Cronograma</strong> de Execução Físico :
      </h2>

      <Table
        listTitle={[
          "Etapa/Fase",
          "Descrição da Meta",
          "Indicador",
          "Duração",
          "",
        ]}
        styleList={[1, 0, 1, 1, 0]}
      >
        {listaMetas.map((metaObj, index) => (
          <RowCronoFisico key={index} metaObj={metaObj}>
            <button
              className={styles.btn}
              onClick={() => setEditModalIndex(index)}
            >
              Editar
            </button>
            <Modal
              open={showEditModelIndex === index}
              onClose={() => setEditModalIndex(-1)}
              center
              classNames={{
                modal: "customModal",
              }}
            >
              <ModalMetaExecucaoFisica
                refMeta={listaMetas[index]}
                closeModal={() => setEditModalIndex(-1)}
                index={index}
                setList={setMetas}
                list={listaMetas}
              />
            </Modal>
          </RowCronoFisico>
        ))}
      </Table>
      <div className={styles.addDiv}>
        <button
          className={styles.addBtn}
          onClick={() => {
            setModal(true);
          }}
        >
          + Adicionar Meta
        </button>
      </div>
      <Modal
        open={showModel}
        onClose={() => setModal(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <ModalMetaExecucaoFisica
          closeModal={() => setModal(false)}
          list={listaMetas}
          setList={setMetas}
        />
      </Modal>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default CronogramaExecucao;
